export default "__VITE_ASSET__BdDhsdJd__"